import {memo} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEmpty';
import {Typography} from '@mui/material';
import CentralPageModuleBox from './centralPageModuleBox';
import CircularProgress from '@mui/material/CircularProgress';
import {useCentralPageStyles} from '../centralPageStyles';

const ActiveModules = ({ activeModules, isCentralPage, modulesLoading, tileSize, paperBackground }) => {
  const { t } = useTranslation();
  const classes = useCentralPageStyles();

  return modulesLoading ? (
      <CircularProgress className={classes.loadingIcon} />
      ) : _isEmpty(activeModules) ?
    <Typography>
        {t('No active modules. Please upgrade to continue.')}
    </Typography> :
    activeModules.map((module) => (
      <CentralPageModuleBox
        key={module.id}
        module={module}
        tileSize={tileSize}
        isCentralPage={isCentralPage}
        paperBackground={paperBackground}
      />
      )
    )
}

ActiveModules.propTypes = {
  activeModules: PropTypes.array.isRequired,
  isCentralPage: PropTypes.bool,
  paperBackground: PropTypes.bool,
  tileSize: PropTypes.oneOf(['small', 'medium', 'large']),
}

ActiveModules.defaultProps = {
  tileSize: 'large',
  isCentralPage: false,
  paperBackground: false,
}

export default memo(ActiveModules, _isEqual);